import { UseQueryOptions } from '@tanstack/react-query';
import useAppQuery from 'hooks/useAppQuery';
import { GetRoomTypeOptionsResponse } from 'models/PropertyRooms';
import API from 'services/API';

export const ROOM_TYPE_OPTIONS_BASE_QUERY_KEY = 'room-type-options';

type ReactQueryOptions = Omit<
  UseQueryOptions<GetRoomTypeOptionsResponse>,
  'queryKey' | 'queryFn'
>;

type UseFetchRoomTypeOptionsArgs = ReactQueryOptions;

const useFetchRoomTypeOptions = ({
  enabled = true,
  ...options
}: UseFetchRoomTypeOptionsArgs) => {
  return useAppQuery<GetRoomTypeOptionsResponse>({
    queryKey: [ROOM_TYPE_OPTIONS_BASE_QUERY_KEY],
    queryFn: async () => {
      const response = await API.get<GetRoomTypeOptionsResponse>(
        `/api/internal/properties/room-types`,
      );

      return response.data;
    },
    enabled,
    staleTime: 30000,
    keepPreviousData: true,
    ...(options ?? {}),
  });
};

export default useFetchRoomTypeOptions;
